import { render, staticRenderFns } from "./widgetSlider.vue?vue&type=template&id=715ad9c9&scoped=true"
import script from "./widgetSlider.vue?vue&type=script&lang=js"
export * from "./widgetSlider.vue?vue&type=script&lang=js"
import style0 from "./widgetSlider.vue?vue&type=style&index=0&id=715ad9c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ad9c9",
  null
  
)

export default component.exports